import React, { useEffect } from "react";
import { Container, Row, Col } from "react-bootstrap";
import DashboardCards from "../components/DashboardCards/DashboardCards";
import { FaDollarSign, FaUserPlus, FaChartLine } from "react-icons/fa";
import "../styles/Dashboard.css";
import LineChartComponent from "../components/LineGraphComponent/LineChartComponent";
import BarChartComponent from "../components/GraphComponent/BarChartComponent";
import TableComponent from "../components/TableComponent/TableComponent";
import FarmerMap from "../components/FarmerMap/FarmerMap";
import TitleComponent from "../components/TitleComponent/TitleComponent";
import FeedbacksComponent from "../components/FeedbacksComponent/FeedbacksComponent";
import { ICONS } from "../constants/constants";
import { useLocation, useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { handleGetSupplierRating } from "../store/actions/suppliersActions";

const Feedbacks = () => {
  const location = useLocation();
  const dispatch = useDispatch();
  const supplierId = location.state?.id;

  useEffect(() => {
    if (supplierId) {
      dispatch(handleGetSupplierRating(supplierId)); // Fetch supplier rating
    }
  }, [dispatch, supplierId]);
  const supplierRating = useSelector((state) => state.supplier.supplierRating);


  const feedbackData = {
    supplierId,
    averageRating:
      supplierRating?.ratings?.reduce(
        (sum, rating) => sum + rating.star_count,
        0
      ) / (supplierRating?.ratings?.length || 1), // Calculate average
    totalReviews: supplierRating?.ratings?.length || 0, // Total reviews count
    reviews: supplierRating?.ratings?.map((rating) => ({
      customerName: "New Farmer", // Replace with actual customer name if available
      ratingdate: rating.created_at,
      rating: rating.star_count,
      comment: rating.review_description,
    })),
  };

  const enablePagination = true;

  return (
    <Container>
      <Row>
        <Col lg={12} className="component-container">
          <Row className="component-container py-3">
            <Col lg={12}>
              <div className="custom-breadcrumb">
                {/* <span><a href="/">Home</a></span> */}
                <img src={ICONS.supplier} className="icon" />
                <span>
                  <a href="/suppliers">Suppliers</a>
                </span>
                {/* <span>
                  <a href="/supplier">{userData.name}({userData.id})</a>
                </span> */}
                <span>Feedbacks</span>
              </div>
            </Col>
          </Row>
        </Col>

        {/* <Col lg={12}>
    <div className="custom-breadcrumb">
      
<img src={ICONS.supplier} className='icon'/>
      <span><a href="/supplier">Suppliers</a></span>
      <span><a href="/supplier">Andrew</a></span>
      <span>Feedbacks</span>
    </div>
  </Col> */}
        <Col lg={12} className="component-container mb-2">
          {/* <TitleComponent title="Feedbacks" /> */}
          <FeedbacksComponent
            {...feedbackData}
            title="Feedbacks"
            enablePagination={enablePagination}
          />
        </Col>
      </Row>
    </Container>
  );
};

export default Feedbacks;
